var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/weight"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M6.33333 23.6663H15.6667C19.1667 23.6663 21.5 21.333 21.5 17.833V6.16634C21.5 2.66634 19.1667 0.333008 15.6667 0.333008H6.33333C2.83333 0.333008 0.5 2.66634 0.5 6.16634V17.833C0.5 21.333 2.83333 23.6663 6.33333 23.6663Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4173 7.33285C13.7656 4.07785 8.24729 4.07785 4.58396 7.33285C4.42063 7.48452 4.38562 7.71785 4.50229 7.89285L7.04562 11.9762C7.11562 12.0812 7.23229 12.1629 7.34896 12.1745C7.47729 12.1979 7.60563 12.1512 7.69896 12.0695C9.57729 10.4012 12.4006 10.4012 14.279 12.0695C14.3606 12.1395 14.4656 12.1745 14.5706 12.1745C14.594 12.1745 14.6173 12.1745 14.629 12.1745C14.7573 12.1512 14.874 12.0812 14.9323 11.9762L17.4756 7.89285C17.6156 7.71785 17.5806 7.48452 17.4173 7.33285Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.284ec00eff0c391f059d28ca48ff8910.svg";
export { ForwardRef as ReactComponent };